import QRCode from "qrcode";

export const CHURCH_LOGO_URL = "/assets/igreja-carvalhos-logo.png";

function loadImage(source: string) {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = source;
  });
}

export async function createBrandedQr(value: string, size = 280) {
  const canvas = document.createElement("canvas");
  await QRCode.toCanvas(canvas, value, { width: size, margin: 2, errorCorrectionLevel: "H", color: { dark: "#000000", light: "#ffffff" } });
  const context = canvas.getContext("2d");
  if (!context) return canvas.toDataURL("image/png");
  const logo = await loadImage(CHURCH_LOGO_URL);
  const boxSize = Math.round(size * 0.2);
  const boxX = Math.round((size - boxSize) / 2);
  const radius = Math.round(boxSize * 0.2);
  context.save();
  context.fillStyle = "#ffffff";
  context.beginPath();
  context.roundRect(boxX, boxX, boxSize, boxSize, radius);
  context.fill();
  const padding = Math.round(boxSize * 0.14);
  context.beginPath();
  context.roundRect(boxX + padding, boxX + padding, boxSize - padding * 2, boxSize - padding * 2, radius * 0.65);
  context.clip();
  context.drawImage(logo, boxX + padding, boxX + padding, boxSize - padding * 2, boxSize - padding * 2);
  context.restore();
  return canvas.toDataURL("image/png");
}

export function downloadDataUrl(dataUrl: string, filename: string) {
  const link = document.createElement("a");
  link.href = dataUrl;
  link.download = filename;
  link.click();
}
